export default {
    screenList: {
        method: "POST",
        url: "/adminScreen/screen-user/screen-size-list",
        name: "大屏分辨率列表"
    },
    screenSet: {
        method: "POST",
        url: "/adminScreen/screen-user/screen-set-size",
        name: "大屏分辨率新增&编辑"
    },
    screenInfo: {
        method: "POST",
        url: "/adminScreen/screen-user/screen-size-info",
        name: "大屏分辨率详情"
    },
};